import { render, staticRenderFns } from "./CheckOCRReadFileDialogZS.vue?vue&type=template&id=6a4e6e5b&scoped=true&"
import script from "./CheckOCRReadFileDialogZS.vue?vue&type=script&lang=js&"
export * from "./CheckOCRReadFileDialogZS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4e6e5b",
  null
  
)

export default component.exports